import Vue from 'vue'
import VueRouter from 'vue-router'

import NavTree from '@/router/menu-tree'
import store from '@/store/index'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: NavTree
})

router.beforeEach((to, from, next) => {

  const { authorize } = to.meta;


  var currentUser = store.getters.userInfo;

  //if not logged in or store not populated by app.vue mounted script
  if (!currentUser) {
    //not logged in so just wait for navigation authorizer to handle it when it mounts
    next();
  }
  //if: route is restricted by role and you dont have that role
  else if (authorize && authorize.length > 0 && !authorize.includes(currentUser.UserTypeId)) {
    store.dispatch("navstore/setBrokenPermission", true);
  }
  //else: you have the role or there is no role restriction
  else {
    store.dispatch("navstore/setBrokenPermission", false);
  }

  next();
})


export default router;
